

// REPO PATH:  src/front-end/code/app/Modal/confirm.js
//
// REVERT-NOTE(unified-notify): NEW FILE — part of the notification
// unification branch. Delete with app/Modal if reverting; every migrated
// call site keeps its original window.confirm line commented out beside it.
//
// Promise-based replacement for window.confirm, so migration is mechanical:
//
//   if (!window.confirm(msg)) return;              // before
//   if (!(await confirmDialog(msg))) return;       // after
//
// Options: { title, confirmLabel, cancelLabel, danger }. If <ConfirmHost/>
// isn't mounted (it is, in Splash.js), falls back to native window.confirm
// so nothing can dead-end.
//
// NOT used for DataAdmin's "Clean up data" confirms — those are a deliberate
// check-impact-then-confirm flow with record counts, which a generic dialog
// would flatten. They stay as they are on purpose.

import React, { useEffect, useState } from 'react';
import Modal from './';
import styles from './modal.module.css';

let host = null;

export function confirmDialog(message, opts = {}) {
    return new Promise((resolve) => {
        if (!host) {
            resolve(window.confirm(message));
            return;
        }
        host({ message, opts, resolve });
    });
}

export const ConfirmHost = () => {
    const [req, setReq] = useState(null);

    useEffect(() => {
        host = setReq;
        return () => { host = null; };
    }, []);

    if (!req) return null;

    const answer = (ok) => {
        req.resolve(ok);
        setReq(null);
    };

    const { title, confirmLabel, cancelLabel, danger } = req.opts;

    return (
        <Modal
            open
            title={title || 'Please confirm'}
            onClose={() => answer(false)}
            footer={
                <>
                    <button type="button" className={styles.btnSecondary} onClick={() => answer(false)}>
                        {cancelLabel || 'Cancel'}
                    </button>
                    <button
                        type="button"
                        className={danger ? styles.btnDanger : styles.btnPrimary}
                        onClick={() => answer(true)}
                    >
                        {confirmLabel || 'Confirm'}
                    </button>
                </>
            }
        >
            <p style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{req.message}</p>
        </Modal>
    );
};